var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 7.75,
    fill: "white",
    stroke: "#E0E6EE",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87038 23.4801H11.0556V15.7578L6.5 12.3689V22.1282C6.5 22.8689 7.11111 23.4801 7.87038 23.4801Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9443 23.4801H25.1295C25.8888 23.4801 26.4999 22.8689 26.4999 22.1097V12.3689L21.9629 15.7763V23.4801H21.9443Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9443 9.86896V15.7764L26.4814 12.369V10.5541C26.4814 8.86895 24.5555 7.90598 23.2036 8.92451L21.9443 9.86896Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0371 15.7578V9.8689L16.4816 13.9615L21.926 9.8689V15.7763L16.5001 19.8504L11.0371 15.7578Z",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.5356V12.3504L11.0371 15.7578V9.86892L9.75927 8.90596C8.42593 7.90595 6.5 8.86892 6.5 10.5356Z",
    fill: "#C5221F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMail);
export default __webpack_public_path__ + "static/media/google-mail.0cf06dd8c705ba4f0d7964e1fd4f30d2.svg";
export { ForwardRef as ReactComponent };